import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useCallback, useMemo } from 'react';
import { Spin } from 'antd';
import { reject } from 'ramda';
import { GoogleMap, useJsApiLoader, Marker, MarkerClusterer } from '@react-google-maps/api';
import config from 'constants/config';
import { isNilOrEmpty } from 'utils/helpers';
import { DEFAULT_CENTER, markerToBoundsWithDefaults, findExtremePoints } from './helpers';
var containerStyle = {
    width: '100%',
    height: '100%'
};
var Map = function (_a) {
    var _b = _a.leftClickOpens, leftClickOpens = _b === void 0 ? false : _b, _c = _a.rightClickOpens, rightClickOpens = _c === void 0 ? false : _c, _d = _a.markers, markers = _d === void 0 ? [] : _d, _e = _a.maxZoom, maxZoom = _e === void 0 ? false : _e;
    var isLoaded = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: config === null || config === void 0 ? void 0 : config.GOOGLE_MAPS_TOKEN
    }).isLoaded;
    var cleanMarkers = useMemo(function () {
        if (isNilOrEmpty(markers))
            return [];
        return reject(function (marker) { return isNilOrEmpty(marker.latitude) || isNilOrEmpty(marker.longitude); }, markers);
    }, [JSON.stringify(markers)]);
    var firstMarker = useMemo(function () {
        return cleanMarkers[0] ? markerToBoundsWithDefaults(cleanMarkers[0]) : false;
    }, [cleanMarkers]);
    // eslint-disable-next-line
    var _f = useState(null), map = _f[0], setMap = _f[1];
    var onLoad = useCallback(function (m) {
        if (!m)
            return;
        var extremes = findExtremePoints(cleanMarkers);
        var bounds = new window.google.maps.LatLngBounds();
        if (extremes) {
            bounds.extend(extremes.mostNorthEastern);
            bounds.extend(extremes.mostSouthWestern);
            if (!maxZoom)
                m.setOptions({ maxZoom: undefined });
        }
        else {
            bounds.extend(DEFAULT_CENTER);
            if (!maxZoom)
                m.setOptions({ maxZoom: 10 });
        }
        if (maxZoom)
            m.setOptions({ maxZoom: maxZoom });
        m.fitBounds(bounds);
        setMap(m);
    }, [firstMarker]);
    var onUnmount = useCallback(function () {
        setMap(null);
    }, []);
    var onClick = function (item) {
        if (leftClickOpens)
            window.open("".concat(leftClickOpens, "/").concat(item.id));
    };
    var onRightClick = function (item) {
        if (rightClickOpens)
            window.open(item === null || item === void 0 ? void 0 : item[rightClickOpens]);
    };
    return isLoaded ? (_jsx(GoogleMap, { mapContainerStyle: containerStyle, center: firstMarker || DEFAULT_CENTER, zoom: 13, onLoad: onLoad, onUnmount: onUnmount, children: _jsx(MarkerClusterer, { minimumClusterSize: 2, averageCenter: true, children: function (clusterer) { return (_jsx("div", { children: cleanMarkers.map(function (marker, i) {
                    var position = new window.google.maps.LatLng(marker.latitude, marker.longitude);
                    return (_jsx(Marker, { position: position, onClick: function () { return onClick(marker); }, onRightClick: function () { return onRightClick(marker); }, title: "".concat((cleanMarkers === null || cleanMarkers === void 0 ? void 0 : cleanMarkers.length) > 1 ? "".concat(i + 1, ". ") : '').concat(marker.name), label: (cleanMarkers === null || cleanMarkers === void 0 ? void 0 : cleanMarkers.length) > 1 ? "".concat(i + 1) : undefined, animation: window.google.maps.Animation.DROP, clusterer: clusterer }, marker.id));
                }) })); } }) })) : (_jsx(Spin, { spinning: true }));
};
export default React.memo(Map);
